/* ============================================================
   SEPAL · New Launch — Paddock Stand
   assets/new-launch-product.js

   - No dependencies.
   - Page frame: edge to edge, no gaps above the navbar / below the
     footer, room under a fixed navbar.
   - Reveal-on-scroll, hero parallax (desktop), model buttons,
     swipe dots, floating buy bar.
   - Purchase form: variant matching, hidden variants, theme / AJAX
     add to cart, Buy now.
   ============================================================ */
(function () {
  'use strict';

  if (window.SepalLaunch) return;

  /* ---------------- helpers ---------------- */
  var clamp = function (v, a, b) { return v < a ? a : v > b ? b : v; };
  var norm = function (s) { return (s == null ? '' : String(s)).trim().toLowerCase().replace(/\s+/g, ' '); };
  var firstNumber = function (s) { var m = String(s || '').match(/\d+(?:\.\d+)?/); return m ? m[0] : null; };
  var round = function (v, d) { var f = Math.pow(10, d || 3); return Math.round(v * f) / f; };
  var mq = function (q) { return window.matchMedia ? window.matchMedia(q) : { matches: false }; };
  var reduceMQ = mq('(prefers-reduced-motion: reduce)');

  /* ---------------- money ----------------
     Mirrors Shopify's money formats and Liquid's
     money_without_trailing_zeros (drops ".00"). */
  function delimit(cents, precision, thousands, decimal) {
    thousands = thousands == null ? ',' : thousands;
    decimal = decimal == null ? '.' : decimal;
    var n = (cents / 100).toFixed(precision);
    var parts = n.split('.');
    var whole = parts[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1' + thousands);
    return parts[1] ? whole + decimal + parts[1] : whole;
  }

  function formatMoney(cents, format) {
    cents = Math.round(Number(cents) || 0);
    var fmt = String(format || '{{amount}}').replace(/<[^>]*>/g, '');
    var p = cents % 100 === 0 ? 0 : 2;
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, key) {
      switch (key) {
        case 'amount': return delimit(cents, p);
        case 'amount_no_decimals': return delimit(cents, 0);
        case 'amount_with_comma_separator': return delimit(cents, p, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return delimit(cents, 0, '.', ',');
        case 'amount_with_apostrophe_separator': return delimit(cents, p, "'", '.');
        case 'amount_no_decimals_with_space_separator': return delimit(cents, 0, ' ', ',');
        case 'amount_with_space_separator': return delimit(cents, p, ' ', ',');
        case 'amount_with_period_and_space_separator': return delimit(cents, p, ' ', '.');
        default: return delimit(cents, p);
      }
    });
  }

  /* ============================================================
     PURCHASE
     ============================================================ */
  function Purchase(root, data) {
    this.root = root;
    this.data = data;
    this.strings = data.strings || {};
    this.form = root.querySelector('form[data-sepal-form]');
    if (!this.form) return;

    this.idInput = this.form.querySelector('input[name="id"]');
    this.fieldsets = Array.prototype.slice.call(this.form.querySelectorAll('[data-option-index]'));
    this.qty = this.form.querySelector('[data-qty]');
    this.addBtn = this.form.querySelector('[data-add]');
    this.addLabel = this.form.querySelector('[data-add-label]');
    this.buyNow = this.form.querySelector('[data-buy-now]');
    this.status = this.form.querySelector('[data-status]');
    this.added = this.form.querySelector('[data-added]');
    this.el = {
      price: root.querySelector('[data-price]'),
      priceLabel: root.querySelector('[data-price-label]'),
      compare: root.querySelector('[data-compare]'),
      compareValue: root.querySelector('[data-compare-value]'),
      savings: root.querySelector('[data-savings]'),
      badge: root.querySelector('[data-sale-badge]'),
      stock: root.querySelector('[data-stock]'),
      barPrice: root.querySelector('[data-bar-price]'),
      layers: Array.prototype.slice.call(root.querySelectorAll('[data-buy-layer]'))
    };

    this.busy = false;
    this.lastSubmitter = null;
    this.resetTimer = null;

    var all = data.variants || [];
    this.hidden = this.parseCombos(data.hiddenCombinations);
    var visible = all.filter(function (v) { return !this.isHidden(v); }, this);
    this.variants = visible.length ? visible : all;
    this.annotations = this.parseAnnotations(data.annotations);

    this.bind();
    this.annotate();
    this.selected = this.readSelection();
    this.cascade(0);
    this.update(false);
  }

  Purchase.prototype.parseCombos = function (text) {
    return String(text || '').split(/\r?\n/).map(function (line) {
      return line.split('|').map(norm);
    }).filter(function (parts) { return parts.some(Boolean); });
  };

  Purchase.prototype.isHidden = function (variant) {
    var opts = (variant.options || []).map(norm);
    return this.hidden.some(function (parts) {
      return parts.every(function (part, i) { return !part || part === opts[i]; });
    });
  };

  Purchase.prototype.parseAnnotations = function (text) {
    return String(text || '').split(/\r?\n/).map(function (line) {
      var at = line.indexOf('=');
      if (at < 1) return null;
      var key = norm(line.slice(0, at));
      var note = line.slice(at + 1).trim();
      return key && note ? { key: key, note: note, numeric: /^\d+(?:\.\d+)?$/.test(key) } : null;
    }).filter(Boolean);
  };

  Purchase.prototype.noteFor = function (value) {
    var v = norm(value), num = firstNumber(value);
    for (var i = 0; i < this.annotations.length; i++) {
      var a = this.annotations[i];
      if (a.key === v || (a.numeric && num === a.key)) return a.note;
    }
    return '';
  };

  Purchase.prototype.annotate = function () {
    var self = this;
    this.fieldsets.forEach(function (fs) {
      fs.querySelectorAll('[data-option-input]').forEach(function (input) {
        var noteEl = input.closest('[data-chip]').querySelector('[data-chip-note]');
        var note = self.noteFor(input.value);
        if (noteEl) { noteEl.textContent = note; noteEl.hidden = !note; }
      });
    });
  };

  Purchase.prototype.inputs = function (fs) {
    return Array.prototype.slice.call(fs.querySelectorAll('[data-option-input]'));
  };

  Purchase.prototype.readSelection = function () {
    return this.fieldsets.map(function (fs) {
      var checked = fs.querySelector('[data-option-input]:checked');
      return checked ? checked.value : null;
    });
  };

  /* variants matching the first `len` selected values */
  Purchase.prototype.matching = function (values, len) {
    return this.variants.filter(function (v) {
      for (var i = 0; i < len; i++) {
        if (norm(v.options[i]) !== norm(values[i])) return false;
      }
      return true;
    });
  };

  /* Keep every option at index >= from valid for the options before it */
  Purchase.prototype.cascade = function (from) {
    for (var j = from; j < this.fieldsets.length; j++) {
      var prefix = this.selected.slice(0, j);
      var candidates = this.matching(prefix, j);
      var current = this.selected[j];
      var ok = current != null && candidates.some(function (v) { return norm(v.options[j]) === norm(current); });
      if (ok) continue;

      var values = this.inputs(this.fieldsets[j]).map(function (i) { return i.value; });
      var pick = null;
      for (var k = 0; k < values.length && !pick; k++) {
        if (candidates.some(function (v) { return v.available && norm(v.options[j]) === norm(values[k]); })) pick = values[k];
      }
      for (k = 0; k < values.length && !pick; k++) {
        if (candidates.some(function (v) { return norm(v.options[j]) === norm(values[k]); })) pick = values[k];
      }
      this.selected[j] = pick;
    }
    this.syncInputs();
  };

  Purchase.prototype.syncInputs = function () {
    var self = this;
    var soldSr = this.strings.soldOutSr || 'sold out';
    this.fieldsets.forEach(function (fs, j) {
      var prefix = self.selected.slice(0, j);
      self.inputs(fs).forEach(function (input) {
        var chip = input.closest('[data-chip]');
        var matches = self.matching(prefix.concat([input.value]), j + 1);
        var exists = matches.length > 0;
        var available = matches.some(function (v) { return v.available; });

        chip.hidden = !exists;
        input.disabled = !exists;
        input.checked = exists && norm(input.value) === norm(self.selected[j]);
        chip.classList.toggle('is-soldout', exists && !available);
        var sr = chip.querySelector('[data-chip-sr]');
        if (sr) sr.textContent = exists && !available ? ', ' + soldSr : '';
      });
    });
  };

  Purchase.prototype.current = function () {
    if (!this.fieldsets.length) return this.variants[0] || null;
    var n = this.fieldsets.length;
    var sel = this.selected;
    for (var i = 0; i < this.variants.length; i++) {
      var v = this.variants[i], ok = true;
      for (var j = 0; j < n; j++) {
        if (norm(v.options[j]) !== norm(sel[j])) { ok = false; break; }
      }
      if (ok) return v;
    }
    return null;
  };

  Purchase.prototype.money = function (cents, withSuffix) {
    return formatMoney(cents, this.data.moneyFormat) + (withSuffix ? (this.data.priceSuffix || '') : '');
  };

  Purchase.prototype.update = function (announce) {
    var v = this.current();
    var s = this.strings, el = this.el;
    this.variant = v;

    if (this.idInput) {
      if (v) this.idInput.value = v.id;
      this.idInput.disabled = !v;
    }

    var onSale = !!(v && v.compareAtPrice > v.price);
    if (v) {
      if (el.price) el.price.textContent = this.money(v.price, true);
      if (el.barPrice) el.barPrice.textContent = this.money(v.price, true);
    }
    if (el.priceLabel) el.priceLabel.textContent = onSale ? (s.salePrice || 'Sale price') : (s.price || 'Price');
    if (el.compare) el.compare.hidden = !onSale;
    if (el.compareValue) el.compareValue.textContent = onSale ? this.money(v.compareAtPrice, true) : '';
    if (el.badge) el.badge.hidden = !onSale;
    if (el.savings) {
      el.savings.hidden = !onSale;
      if (onSale) {
        var diff = v.compareAtPrice - v.price;
        var pct = Math.round((diff * 100) / v.compareAtPrice);
        el.savings.textContent = String(s.save || 'You save {amount} ({percent}%)')
          .replace('{amount}', this.money(diff, false))
          .replace('{percent}', pct);
      } else {
        el.savings.textContent = '';
      }
    }

    var available = !!(v && v.available);
    if (el.stock) {
      el.stock.textContent = !v ? (s.unavailable || 'Unavailable') : available ? (s.inStock || 'In stock') : (s.soldOut || 'Sold out');
      el.stock.classList.toggle('is-in', available);
      el.stock.classList.toggle('is-out', !available);
    }
    if (!this.busy) this.setButton(available ? 'idle' : v ? 'soldout' : 'unavailable');

    if (v && v.mediaKey && el.layers.length) {
      var target = el.layers.filter(function (l) { return l.getAttribute('data-media-key') === v.mediaKey; })[0];
      if (target) el.layers.forEach(function (l) { l.classList.toggle('is-active', l === target); });
    }

    if (announce) {
      this.clearStatus();
      this.root.dispatchEvent(new CustomEvent('sepal-launch:variant-change', { bubbles: true, detail: { variant: v } }));
    }
  };

  Purchase.prototype.setButton = function (state) {
    var s = this.strings;
    var labels = {
      idle: s.addToCart || 'Add to cart',
      adding: s.adding || 'Adding…',
      added: s.added || 'Added',
      soldout: s.soldOut || 'Sold out',
      unavailable: s.unavailable || 'Unavailable'
    };
    var purchasable = state === 'idle' || state === 'added';
    if (this.addBtn) {
      this.addBtn.disabled = !purchasable && state !== 'adding';
      this.addBtn.setAttribute('data-state', state);
      this.addBtn.setAttribute('aria-busy', state === 'adding' ? 'true' : 'false');
    }
    if (this.addLabel) this.addLabel.textContent = labels[state];
    if (this.buyNow) this.buyNow.disabled = !purchasable;
  };

  Purchase.prototype.clearStatus = function () {
    if (this.status) { this.status.textContent = ''; this.status.classList.remove('is-error'); }
    if (this.added) this.added.hidden = true;
  };

  Purchase.prototype.quantity = function () {
    var q = parseInt(this.qty ? this.qty.value : '1', 10);
    return isFinite(q) && q > 0 ? q : 1;
  };

  Purchase.prototype.bind = function () {
    var self = this;

    this._change = function (e) {
      var input = e.target;
      if (!input.matches || !input.matches('[data-option-input]')) return;
      var idx = self.fieldsets.indexOf(input.closest('[data-option-index]'));
      if (idx < 0) return;
      self.selected[idx] = input.value;
      self.cascade(idx + 1);
      self.update(true);
    };

    this._click = function (e) {
      var stepBtn = e.target.closest('[data-qty-step]');
      if (stepBtn && self.qty) {
        self.qty.value = Math.max(1, self.quantity() + parseInt(stepBtn.getAttribute('data-qty-step'), 10));
        self.qty.dispatchEvent(new Event('change', { bubbles: true }));
        return;
      }
      var submitter = e.target.closest('button[type="submit"], input[type="submit"]');
      if (submitter) self.lastSubmitter = submitter;
    };

    this._qty = function () { if (self.qty) self.qty.value = self.quantity(); };
    this._submit = function (e) { self.submit(e); };

    this.form.addEventListener('change', this._change);
    this.form.addEventListener('click', this._click);
    if (this.qty) this.qty.addEventListener('blur', this._qty);
    this.form.addEventListener('submit', this._submit);
  };

  Purchase.prototype.submit = function (e) {
    var submitter = e.submitter || this.lastSubmitter;
    this.lastSubmitter = null;
    var v = this.variant;

    if (!v || !v.available) { e.preventDefault(); return; }

    /* Buy now → cart permalink: a checkout with only this item */
    if (submitter && submitter.hasAttribute('data-buy-now')) {
      e.preventDefault();
      var rootUrl = String(this.data.rootUrl || '/').replace(/\/?$/, '/');
      window.location.href = rootUrl + 'cart/' + v.id + ':' + this.quantity();
      return;
    }

    /* Preferred: the theme's own form, so its cart popup opens
       exactly like on the product page. */
    if (this.themeAdd(v)) { e.preventDefault(); return; }

    if (!window.fetch || !window.FormData) return; // native submit
    e.preventDefault();
    if (this.busy) return;

    var self = this;
    var body = new FormData(this.form);
    var drop = [];
    body.forEach(function (_, key) { if (key.indexOf('sl-') === 0 || key === 'return_to') drop.push(key); });
    drop.forEach(function (key) { body.delete(key); });
    body.set('id', v.id);
    body.set('quantity', this.quantity());

    this.busy = true;
    clearTimeout(this.resetTimer);
    this.clearStatus();
    this.setButton('adding');

    fetch(this.data.cartAddUrl, {
      method: 'POST',
      headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: body,
      credentials: 'same-origin'
    })
      .then(function (res) {
        return res.json().catch(function () { return {}; }).then(function (json) {
          if (!res.ok || json.status) throw new Error(json.description || json.message || self.strings.error);
          return json;
        });
      })
      .then(function (item) {
        if (self.data.afterAdd === 'cart') { window.location.href = self.data.cartUrl; return; }
        self.busy = false;
        self.setButton('added');
        if (self.status) self.status.textContent = self.strings.addedStatus || 'Added to your cart.';
        self.refreshCount();
        self.root.dispatchEvent(new CustomEvent('sepal-launch:cart-added', { bubbles: true, detail: { item: item, variant: v, quantity: self.quantity() } }));
        if (self.data.afterAdd === 'popup') {
          self.openThemeCart().then(function (opened) { if (!opened && self.added) self.added.hidden = false; });
        } else if (self.added) {
          self.added.hidden = false;
        }
        self.resetTimer = setTimeout(function () {
          if (!self.busy) self.setButton(self.variant && self.variant.available ? 'idle' : 'soldout');
        }, 2600);
      })
      .catch(function (err) {
        self.busy = false;
        self.setButton(self.variant && self.variant.available ? 'idle' : 'soldout');
        if (self.status) {
          self.status.classList.add('is-error');
          self.status.textContent = (err && err.message) || self.strings.error;
        }
      });
  };

  /* ---------- Theme add-to-cart (hidden theme form) ---------- */
  Purchase.prototype.themeAdd = function (v) {
    var wrap = this.root.querySelector('[data-theme-form]');
    if (!wrap) return false;
    var tform = wrap.querySelector('form');
    var btn = wrap.querySelector('[data-node-type="commerce-add-to-cart-button"], input[type="submit"], button[type="submit"]');
    if (!tform || !btn) return false;

    var selects = Array.prototype.slice.call(tform.querySelectorAll('select[data-node-type="add-to-cart-option-select"], select[name^="option"]'));
    var ok = true;
    (v.options || []).forEach(function (val, i) {
      var sel = selects[i];
      if (!sel) return;
      var target = norm(val);
      var opts = Array.prototype.slice.call(sel.options);
      var match = opts.filter(function (o) { return norm(o.value) === target || norm(o.getAttribute('data-base-label') || o.textContent) === target; })[0]
        || opts.filter(function (o) { return norm(o.textContent).indexOf(target) === 0; })[0];
      if (!match) { ok = false; return; }
      match.disabled = false;
      sel.value = match.value;
      match.selected = true;
      sel.dispatchEvent(new Event('input', { bubbles: true }));
      sel.dispatchEvent(new Event('change', { bubbles: true }));
    });
    if (!ok) return false;

    var idInput = tform.querySelector('[name="id"]');
    if (idInput) idInput.value = v.id;
    var q = tform.querySelector('[name="quantity"]');
    if (!q) { q = document.createElement('input'); q.type = 'hidden'; q.name = 'quantity'; tform.appendChild(q); }
    q.value = this.quantity();

    var self = this;
    var errBox = wrap.querySelector('.w-commerce-commerceaddtocarterror, [data-node-type="commerce-add-to-cart-error"]');
    this.clearStatus();
    this.setButton('adding');
    setTimeout(function () {
      if (idInput) idInput.value = v.id;
      btn.disabled = false;
      btn.click();
    }, 60);
    setTimeout(function () {
      if (errBox && getComputedStyle(errBox).display !== 'none') {
        self.setButton(v.available ? 'idle' : 'soldout');
        if (self.status) {
          self.status.classList.add('is-error');
          self.status.textContent = (errBox.innerText || '').trim() || self.strings.error;
        }
        return;
      }
      self.setButton('added');
      self.root.dispatchEvent(new CustomEvent('sepal-launch:cart-added', { bubbles: true, detail: { variant: v, quantity: self.quantity() } }));
      clearTimeout(self.resetTimer);
      self.resetTimer = setTimeout(function () {
        if (!self.busy) self.setButton(self.variant && self.variant.available ? 'idle' : 'soldout');
      }, 2200);
    }, 1200);
    return true;
  };

  /* ---------- Theme cart popup (after an AJAX add) ---------- */
  Purchase.prototype.openThemeCart = function () {
    var data = this.data;
    var wrapSel = data.cartWrapperSelector || '.w-commerce-commercecartwrapper';
    var openSel = data.cartOpenSelector || '[data-node-type="commerce-cart-open-link"], .w-commerce-commercecartopenlink';
    var panelSel = '.w-commerce-commercecartcontainerwrapper, [data-node-type="commerce-cart-container-wrapper"]';

    ['cart:refresh', 'cart:updated', 'cart:build', 'udesly:cart:refresh'].forEach(function (name) {
      try { document.dispatchEvent(new CustomEvent(name, { bubbles: true })); } catch (e) { /* ignore */ }
    });

    var isOpen = function () {
      var panels;
      try { panels = document.querySelectorAll(panelSel); } catch (e) { return false; }
      for (var i = 0; i < panels.length; i++) {
        var cs = getComputedStyle(panels[i]);
        if (cs.display !== 'none' && cs.visibility !== 'hidden' && panels[i].getBoundingClientRect().height > 0) return true;
      }
      return false;
    };

    var clickOpen = function () {
      var btn;
      try { btn = document.querySelector(openSel); } catch (e) { btn = null; }
      if (!btn) return false;
      btn.click();
      return true;
    };

    var swap = fetch(window.location.pathname + window.location.search, { credentials: 'same-origin', headers: { Accept: 'text/html' } })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelectorAll(wrapSel);
        var live = document.querySelectorAll(wrapSel);
        for (var i = 0; i < live.length && i < fresh.length; i++) live[i].innerHTML = fresh[i].innerHTML;
        try {
          if (window.Webflow && Webflow.require) {
            var commerce = Webflow.require('commerce');
            if (commerce && commerce.init) commerce.init({ siteId: document.documentElement.getAttribute('data-wf-site') });
          }
        } catch (e) { /* not a Webflow commerce runtime */ }
      })
      .catch(function () {});

    return swap.then(function () {
      if (isOpen()) return true;
      if (!clickOpen()) return false;
      return new Promise(function (resolve) { setTimeout(function () { resolve(isOpen()); }, 450); });
    });
  };

  Purchase.prototype.refreshCount = function () {
    var sel = this.data.cartCountSelector;
    if (!sel || !this.data.cartJsUrl) return;
    var nodes;
    try { nodes = document.querySelectorAll(sel); } catch (e) { return; }
    if (!nodes.length) return;
    fetch(this.data.cartJsUrl, { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) { Array.prototype.forEach.call(nodes, function (n) { n.textContent = cart.item_count; }); })
      .catch(function () {});
  };

  /* Select a value programmatically (used by the model buttons) */
  Purchase.prototype.selectValue = function (index, value) {
    if (!this.form || !this.fieldsets[index]) return;
    var target = norm(value);
    var match = this.inputs(this.fieldsets[index]).filter(function (i) { return norm(i.value) === target && !i.disabled; })[0];
    if (!match) return;
    this.selected[index] = match.value;
    this.cascade(index + 1);
    this.update(true);
  };

  Purchase.prototype.destroy = function () {
    if (!this.form) return;
    clearTimeout(this.resetTimer);
    this.form.removeEventListener('change', this._change);
    this.form.removeEventListener('click', this._click);
    this.form.removeEventListener('submit', this._submit);
    if (this.qty) this.qty.removeEventListener('blur', this._qty);
  };

  /* ============================================================
     LAUNCH (page)
     ============================================================ */
  function Launch(root) {
    this.root = root;
    this.undo = [];
    var dataEl = root.querySelector('[data-sepal-launch-data]');
    try { this.data = dataEl ? JSON.parse(dataEl.textContent) : {}; } catch (e) { this.data = {}; }

    this.purchase = new Purchase(root, this.data);

    var self = this, t = null;
    this.frame();
    this._relayout = function () { self.reset(); self.frame(); };
    this._resize = function () { clearTimeout(t); t = setTimeout(self._relayout, 150); };
    window.addEventListener('resize', this._resize, { passive: true });
    window.addEventListener('load', this._relayout, { once: true });

    this.initReveal();
    this.initHero();
    this.initLinks();
    this.initBar();
    this.initSnap();
    root.classList.add('is-ready');
  }

  /* ---------- page frame ---------- */
  Launch.prototype.frame = function () {
    this.nav = this.findNav();
    this.footer = this.findFooter();
    this.unbox(this.root);
    if (this.nav) { this.unbox(this.nav); this.stretch(this.nav); }
    if (this.footer) { this.unbox(this.footer); this.stretch(this.footer); }
    this.closeGaps();
    this.bleed();
    this.measure();
  };

  Launch.prototype.reset = function () {
    this.undo.forEach(function (u) {
      for (var k in u.saved) {
        if (u.saved[k]) u.el.style.setProperty(k, u.saved[k]); else u.el.style.removeProperty(k);
      }
    });
    this.undo = [];
  };

  Launch.prototype.setStyle = function (el, props) {
    var saved = {};
    for (var k in props) { saved[k] = el.style.getPropertyValue(k); el.style.setProperty(k, props[k], 'important'); }
    this.undo.push({ el: el, saved: saved });
  };

  /* Theme navbar / footer (outside this section) */
  Launch.prototype.findNav = function () {
    var root = this.root;
    var list = document.querySelectorAll('#shopify-section-header, .w-nav, .navbar, [data-collapse], header, [role="banner"]');
    for (var i = 0; i < list.length; i++) {
      if (!root.contains(list[i]) && !list[i].contains(root) && list[i].offsetHeight > 20) return list[i];
    }
    return null;
  };

  Launch.prototype.findFooter = function () {
    var root = this.root;
    var list = document.querySelectorAll('#shopify-section-footer, footer, .footer, [class*="footer"]');
    for (var i = 0; i < list.length; i++) {
      if (!root.contains(list[i]) && !list[i].contains(root) && list[i].offsetHeight > 40) return list[i];
    }
    return null;
  };

  /* Wrappers that box the layout in (max-width / side margins / side
     padding / clipping) are opened up — this page only. */
  Launch.prototype.unbox = function (el) {
    var vw = document.documentElement.clientWidth;
    var a = el ? el.parentElement : null;
    while (a && a !== document.documentElement) {
      var r = a.getBoundingClientRect();
      var cs = getComputedStyle(a);
      if (r.width < vw - 1 || r.left > 0.5 || parseFloat(cs.paddingLeft) > 0 || parseFloat(cs.paddingRight) > 0) {
        this.setStyle(a, { 'max-width': 'none', 'margin-left': '0px', 'margin-right': '0px', 'padding-left': '0px', 'padding-right': '0px' });
        if (cs.display !== 'inline' && a.style.width) this.setStyle(a, { width: 'auto' });
      }
      if (cs.overflowX !== 'visible') this.setStyle(a, { 'overflow-x': 'visible', 'overflow-y': 'visible' });
      a = a.parentElement;
    }
  };

  /* Stretch one element edge to edge (for elements that set their own width) */
  Launch.prototype.stretch = function (el) {
    var vw = document.documentElement.clientWidth;
    if (getComputedStyle(el).position === 'fixed') {
      this.setStyle(el, { left: '0px', right: '0px', width: 'auto', 'max-width': 'none', 'margin-left': '0px', 'margin-right': '0px' });
      return;
    }
    var r = el.getBoundingClientRect();
    if (r.left < 0.5 && Math.abs(r.width - vw) < 1) return;
    this.setStyle(el, { 'box-sizing': 'border-box', 'max-width': 'none', width: vw + 'px', 'margin-left': '0px', 'margin-right': '0px' });
    var left = el.getBoundingClientRect().left;
    if (left > 0.5) this.setStyle(el, { 'margin-left': (-left) + 'px' });
  };

  /* No empty space above the navbar / hero or below the footer:
     top/bottom margins and padding of the wrappers around them are
     removed, and empty spacer divs next to them are hidden. */
  Launch.prototype.closeGaps = function () {
    var self = this;
    var skipTag = /^(SCRIPT|STYLE|LINK|NOSCRIPT|TEMPLATE|META)$/;
    var isSpacer = function (el) {
      if (skipTag.test(el.tagName) || el.offsetHeight === 0) return false;
      var pos = getComputedStyle(el).position;
      if (pos === 'fixed' || pos === 'absolute') return false; // popups, chat, cart: never touched
      return !(el.innerText || '').trim() && !el.querySelector('img, video, svg, iframe, picture, canvas, input, button, a, form');
    };
    var trim = function (el, side) {
      var a = el;
      while (a && a !== document.documentElement) {
        var cs = getComputedStyle(a);
        var props = {};
        if (parseFloat(cs.getPropertyValue('margin-' + side)) > 0) props['margin-' + side] = '0px';
        if (a !== el && parseFloat(cs.getPropertyValue('padding-' + side)) > 0) props['padding-' + side] = '0px';
        if (a !== el && parseFloat(cs.getPropertyValue('border-' + side + '-width')) > 0) props['border-' + side + '-width'] = '0px';
        if (side === 'top' && (cs.position === 'sticky' || cs.position === 'fixed') && parseFloat(cs.top) > 0) props.top = '0px';
        for (var k in props) { self.setStyle(a, props); break; }

        var sib = side === 'top' ? a.previousElementSibling : a.nextElementSibling;
        while (sib) {
          if (isSpacer(sib)) self.setStyle(sib, { display: 'none' });
          sib = side === 'top' ? sib.previousElementSibling : sib.nextElementSibling;
        }
        a = a.parentElement;
      }
    };
    trim(this.nav || this.root, 'top');
    trim(this.root, 'top');
    trim(this.footer || this.root, 'bottom');
    trim(this.root, 'bottom');
  };

  /* Full width even inside a max-width container */
  Launch.prototype.bleed = function () {
    var root = this.root;
    root.style.marginLeft = '0px';
    root.style.width = '';
    root.style.maxWidth = '';
    var vw = document.documentElement.clientWidth;
    var left = root.getBoundingClientRect().left;
    root.style.width = vw + 'px';
    root.style.maxWidth = vw + 'px';
    root.style.marginLeft = (-left) + 'px';
  };

  /* Finds whatever bar really sits on top of the page (fixed / absolute /
     sticky, wherever the theme puts it), pushes the page below it, and
     records where the hero starts. */
  Launch.prototype.measure = function () {
    var root = this.root;
    var hero = root.querySelector('[data-hero]');
    var set = parseFloat(getComputedStyle(root).getPropertyValue('--sl-offset')) || 0;
    var y = window.pageYOffset;
    var vw = document.documentElement.clientWidth;

    root.style.setProperty('--sl-top-space', '0px');
    var rootTop = root.getBoundingClientRect().top + y;

    var cover = 0;   // bottom of bars lying over the top of the page
    var pinned = 0;  // height of bars that stay on screen while scrolling

    if (set) {
      cover = set;
      pinned = set;
    } else {
      var all = document.body.getElementsByTagName('*');
      for (var i = 0; i < all.length; i++) {
        var el = all[i];
        if (root.contains(el)) continue;
        var cs = getComputedStyle(el);
        var pos = cs.position;
        if (pos !== 'fixed' && pos !== 'absolute' && pos !== 'sticky') continue;
        if (cs.display === 'none' || cs.visibility === 'hidden' || parseFloat(cs.opacity) === 0) continue;
        var r = el.getBoundingClientRect();
        if (r.width < vw * 0.6 || r.height < 20 || r.height > 250) continue; // bars only, not popups
        if (pos === 'fixed' && r.top <= 2) {
          cover = Math.max(cover, r.bottom);
          pinned = Math.max(pinned, r.bottom);
        } else if (pos === 'absolute' && r.top + y <= 2) {
          cover = Math.max(cover, r.bottom + y);
        } else if (pos === 'sticky' && r.top <= 2) {
          pinned = Math.max(pinned, r.bottom);
        }
      }
    }

    var space = Math.max(0, Math.round(cover - rootTop));
    root.style.setProperty('--sl-top-space', space + 'px');
    root.style.setProperty('--sl-nav', Math.round(pinned) + 'px');

    var heroTop = hero ? hero.getBoundingClientRect().top + window.pageYOffset : 0;
    root.style.setProperty('--sl-hero-top', Math.round(Math.max(heroTop, 0)) + 'px');
  };

  /* ---------- swipe dots (features on phones) ---------- */
  Launch.prototype.initSnap = function () {
    Array.prototype.forEach.call(this.root.querySelectorAll('[data-snap]'), function (track) {
      var dots = track.parentElement.querySelector('[data-snap-dots]');
      if (!dots) return;
      var items = Array.prototype.filter.call(track.children, function (c) { return c.nodeType === 1; });
      if (items.length < 2) return;
      dots.innerHTML = items.map(function () { return '<i></i>'; }).join('');
      var marks = dots.children;
      var frame = null;
      var update = function () {
        frame = null;
        var mid = track.scrollLeft + track.clientWidth / 2;
        var best = 0, bestD = Infinity;
        items.forEach(function (it, i) {
          var d = Math.abs(it.offsetLeft + it.offsetWidth / 2 - track.offsetLeft - mid);
          if (d < bestD) { bestD = d; best = i; }
        });
        if (track.scrollLeft < 4) best = 0;
        if (track.scrollLeft + track.clientWidth >= track.scrollWidth - 4) best = items.length - 1;
        for (var i = 0; i < marks.length; i++) marks[i].classList.toggle('is-active', i === best);
      };
      track.addEventListener('scroll', function () { if (!frame) frame = requestAnimationFrame(update); }, { passive: true });
      update();
    });
  };

  /* ---------- reveal on scroll ---------- */
  Launch.prototype.initReveal = function () {
    var items = Array.prototype.slice.call(this.root.querySelectorAll('[data-reveal]'));
    if (!items.length) return;
    if (reduceMQ.matches || !('IntersectionObserver' in window)) {
      items.forEach(function (i) { i.classList.add('is-in'); });
      return;
    }
    this.root.classList.add('sepal-launch--reveal');
    this.revealIO = new IntersectionObserver(function (entries, io) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -12% 0px', threshold: 0.05 });
    var io = this.revealIO;
    items.forEach(function (i) { io.observe(i); });
  };

  /* ---------- hero parallax (desktop only) ---------- */
  Launch.prototype.initHero = function () {
    var hero = this.root.querySelector('[data-hero]');
    var bg = hero ? hero.querySelector('[data-hero-bg]') : null;
    if (!bg || reduceMQ.matches || mq('(pointer: coarse)').matches) return;
    var frame = null;
    var update = function () {
      frame = null;
      if (window.innerWidth < 750) { bg.style.transform = ''; return; }
      var r = hero.getBoundingClientRect();
      if (r.bottom < 0 || r.top > window.innerHeight) return;
      var p = clamp(-r.top / Math.max(1, r.height), 0, 1);
      bg.style.transform = 'translate3d(0,' + round(p * 18, 2) + '%,0) scale(1.06)';
    };
    this._heroScroll = function () { if (!frame) frame = requestAnimationFrame(update); };
    window.addEventListener('scroll', this._heroScroll, { passive: true });
    window.addEventListener('resize', this._heroScroll, { passive: true });
    update();
  };

  Launch.prototype.navOffset = function () {
    return parseFloat(getComputedStyle(this.root).getPropertyValue('--sl-nav')) || 0;
  };

  Launch.prototype.scrollToBuy = function () {
    var buy = this.root.querySelector('[data-buy]');
    if (!buy) return;
    var smooth = !reduceMQ.matches;
    var top = buy.getBoundingClientRect().top + window.pageYOffset - this.navOffset();
    window.scrollTo({ top: top, behavior: smooth ? 'smooth' : 'auto' });
    var title = buy.querySelector('[tabindex="-1"]');
    if (title) setTimeout(function () { title.focus({ preventScroll: true }); }, smooth ? 600 : 0);
  };

  /* ---------- in-page links + "Choose ..." buttons ---------- */
  Launch.prototype.initLinks = function () {
    var self = this;
    this._click = function (e) {
      var pick = e.target.closest('[data-pick-model]');
      if (pick && self.root.contains(pick)) {
        e.preventDefault();
        if (self.purchase) self.purchase.selectValue(0, pick.getAttribute('data-pick-model'));
        self.scrollToBuy();
        return;
      }
      var link = e.target.closest('a[data-scroll-to]');
      if (link && self.root.contains(link)) {
        var id = (link.getAttribute('href') || '').slice(1);
        var target = id && document.getElementById(id);
        if (!target) return;
        e.preventDefault();
        if (target.hasAttribute('data-buy')) { self.scrollToBuy(); return; }
        var top = target.getBoundingClientRect().top + window.pageYOffset - self.navOffset();
        window.scrollTo({ top: top, behavior: reduceMQ.matches ? 'auto' : 'smooth' });
      }
    };
    this.root.addEventListener('click', this._click);
  };

  /* ---------- floating buy bar: hidden over the hero and buy section ---------- */
  Launch.prototype.initBar = function () {
    var bar = this.root.querySelector('[data-bar]');
    var buy = this.root.querySelector('[data-buy]');
    var hero = this.root.querySelector('[data-hero]');
    if (!bar || !buy || !('IntersectionObserver' in window)) return;
    var state = { hero: true, buy: false, root: true };
    var self = this;
    var render = function () {
      var show = state.root && !state.hero && !state.buy;
      bar.classList.toggle('is-visible', show);
      bar.setAttribute('aria-hidden', show ? 'false' : 'true');
      bar.setAttribute('tabindex', show ? '0' : '-1');
    };
    this.barIO = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.target === hero) state.hero = e.isIntersecting;
        else if (e.target === buy) state.buy = e.isIntersecting;
        else if (e.target === self.root) state.root = e.isIntersecting;
      });
      render();
    });
    [hero, buy, this.root].forEach(function (t) { if (t) self.barIO.observe(t); });
    this._barClick = function (e) { e.preventDefault(); self.scrollToBuy(); };
    bar.addEventListener('click', this._barClick);
    this.bar = bar;
  };

  Launch.prototype.destroy = function () {
    window.removeEventListener('resize', this._resize);
    window.removeEventListener('load', this._relayout);
    if (this._heroScroll) {
      window.removeEventListener('scroll', this._heroScroll);
      window.removeEventListener('resize', this._heroScroll);
    }
    this.root.removeEventListener('click', this._click);
    if (this.revealIO) this.revealIO.disconnect();
    if (this.barIO) this.barIO.disconnect();
    if (this.bar) this.bar.removeEventListener('click', this._barClick);
    this.reset();
    if (this.purchase) this.purchase.destroy();
  };

  /* ---------------- boot ---------------- */
  var instances = new Map();

  function init(scope) {
    Array.prototype.forEach.call((scope || document).querySelectorAll('[data-sepal-launch]'), function (root) {
      if (instances.has(root)) return;
      try { instances.set(root, new Launch(root)); }
      catch (err) { if (window.console) console.error('[SEPAL launch] init failed', err); }
    });
  }

  function teardown(scope) {
    instances.forEach(function (inst, root) {
      if (scope.contains(root)) { inst.destroy(); instances.delete(root); }
    });
  }

  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  document.addEventListener('shopify:section:unload', function (e) { teardown(e.target); });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();

  window.SepalLaunch = { init: init, formatMoney: formatMoney, instances: instances };
})();